import { render, staticRenderFns } from "./SubjectBalance.vue?vue&type=template&id=6c9c0204&scoped=true&"
import script from "./SubjectBalance.vue?vue&type=script&lang=js&"
export * from "./SubjectBalance.vue?vue&type=script&lang=js&"
import style0 from "./SubjectBalance.vue?vue&type=style&index=0&id=6c9c0204&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c0204",
  null
  
)

export default component.exports